import { PrimeReactProvider } from 'primereact/api';
import React, { PropsWithChildren } from 'react';

// PrimeReact 10.9 overlays (Menu, Dropdown, OverlayPanel and others) read
// PrimeReactContext without a null check when the window scrolls or resizes,
// so every PrimeReact component must render inside this provider.
export const AppPrimeReactProvider = ({ children }: PropsWithChildren) => (
  <PrimeReactProvider>{children}</PrimeReactProvider>
);
